import { http, HttpResponse } from "msw";

import { NangoIntegrationType, NangoTicketingInstance } from "@shared/types";

export const MOCK_TICKETING_INTEGRATION: NangoTicketingInstance = {
  id: "1",
  deployment_id: "1",
  connection_id: "1-abc-uuid-goes-here",
  is_configured: true,
  is_auth_revoked: false,
  instance_type: NangoIntegrationType.Jira,
  subdomain: "semgrep",
  project_id: "10001",
  issue_type_id: "10001",
  fields: {
    sast: {},
    sca: {},
    secrets: {},
  },
  automationStates: {
    sast: false,
    sca: true,
    secrets: false,
  },
};

export const MOCK_TICKETING_INTEGRATION__REVOKED_AUTH: NangoTicketingInstance =
  {
    ...MOCK_TICKETING_INTEGRATION,
    is_auth_revoked: true,
  };

const MOCK_SUBDOMAINS = [
  { id: "123-abc", name: "semgrep" },
  { id: "456-def", name: "not-semgrep" },
];

const MOCK_PROJECTS = [
  { id: "10001", key: "ABC", name: "ABC Project" },
  { id: "10002", key: "DEF", name: "DEF Project" },
  { id: "10003", key: "XYZ", name: "XYZ Project" },
];

const MOCK_ISSUE_TYPES = [
  { id: "10001", name: "Issue Type A", description: "Some description A" },
  { id: "10002", name: "Issue Type B", description: "Some description B" },
  { id: "10003", name: "Issue Type C", description: "Some description C" },
];

const MOCK_ISSUE_TYPE_FIELDS = [
  {
    key: "customfield_10001",
    name: "Default string field",
    hasDefaultValue: true,
    defaultValue: "abc123",
    required: false,
    type: "string",
    options: [],
  },
  {
    key: "customfield_10002",
    name: "Required string field",
    hasDefaultValue: false,
    defaultValue: null,
    required: true,
    type: "string",
    options: [],
  },
  {
    key: "customfield_10003",
    name: "Default option field",
    hasDefaultValue: true,
    defaultValue: { id: "345", value: "Low" },
    required: false,
    type: "option",
    options: ["Low", "Medium", "High", "Critical"],
  },
  {
    key: "customfield_10004",
    name: "Required option field",
    hasDefaultValue: false,
    defaultValue: null,
    required: true,
    type: "option",
    options: ["Low", "Medium", "High", "Critical"],
  },
  {
    key: "customfield_10005",
    name: "Checkbox field",
    hasDefaultValue: false,
    defaultValue: null,
    required: false,
    type: "array",
    options: ["Low", "Medium", "High", "Critical"],
  },
  {
    key: "customfield_10006",
    name: "Paragraph field",
    hasDefaultValue: false,
    defaultValue: null,
    required: false,
    type: "array",
    options: ["Low", "Medium", "High", "Critical"],
  },
];

const MOCK_METADATA_VALIDATION_RESULT = {
  subdomain: true,
  project: true,
  issue_type: true,
};

const PREFIX = "*/api/notifications/deployments/:id/ticketing/v2";

export const ticketingHandlersStatic = [
  // Fetches
  http.get(PREFIX, () =>
    HttpResponse.json([MOCK_TICKETING_INTEGRATION], { status: 200 })
  ),
  http.get(`${PREFIX}/connection_id`, () =>
    HttpResponse.json(MOCK_TICKETING_INTEGRATION.connection_id, {
      status: 200,
    })
  ),
  http.get(`${PREFIX}/public_key`, () =>
    HttpResponse.json("some-fake-key", {
      status: 200,
    })
  ),
  http.get(`${PREFIX}/:instanceId/subdomains`, () =>
    HttpResponse.json(MOCK_SUBDOMAINS, { status: 200 })
  ),
  http.get(`${PREFIX}/:instanceId/projects`, () =>
    HttpResponse.json(MOCK_PROJECTS, { status: 200 })
  ),
  http.get(`${PREFIX}/:instanceId/project/:projectId/issue_types`, () =>
    HttpResponse.json(MOCK_ISSUE_TYPES, { status: 200 })
  ),
  http.get(
    `${PREFIX}/:instanceId/project/:projectId/issue_type/:issueTypeId`,
    () => HttpResponse.json(MOCK_ISSUE_TYPE_FIELDS, { status: 200 })
  ),

  // Saving your changes
  http.put(`${PREFIX}/:instanceId`, () =>
    HttpResponse.json(null, { status: 204 })
  ),

  // Deleting the integration
  http.delete(`${PREFIX}/:instanceId`, () =>
    HttpResponse.json(null, { status: 204 })
  ),

  // Validating connection metadata
  http.get(`${PREFIX}/:instanceId/validate_metadata`, () =>
    HttpResponse.json(MOCK_METADATA_VALIDATION_RESULT, { status: 200 })
  ),
];
